import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  color: ${(props) => props.theme.colors.white100};
`;

export const Header = styled.div`
  padding: .4rem 1.2rem .4rem 1.6rem;
  border-radius: 1.6rem;
  background: ${(props) => props.theme.colors.darkBlue};
  width: fit-content;
  ${(props) => props.theme.fonts.interSemibold13};
  cursor: pointer;
  transition: .3s;
  user-select: none;
  outline: .1rem solid transparent;

  &:hover {
    background: ${(props) => props.theme.colors.darkBlueLight};
  }

  &.active {
    outline: .1rem solid ${(props) => props.theme.colors.white10};
    background: ${(props) => props.theme.colors.darkBlue};
  }
`;

export const Body = styled.div`
  position: absolute;
  left: 0;
  top: 3.6rem;
  height: fit-content;
  max-height: 25.6rem;
  width: 18.7rem;
  background: ${(props) => props.theme.colors.darkBlue};
  border-radius: 1.2rem;
  padding: .8rem;
  opacity: 0;
  transition: .3s;
  pointer-events: none;

  &.active {
    opacity: 1;
    top: 5.6rem;
    pointer-events: all;
  }

  .List {
    display: flex;
    flex-direction: column;
    height: fit-content;
    max-height: 24rem;
    width: 100%;
    overflow: scroll;
    ${(props) => props.theme.mixins.hideScroll};
  }
`;

export const Item = styled.div`
  padding: 0 1.2rem;
  ${(props) => props.theme.fonts.interSemibold13};
  cursor: pointer;
  transition: .3s;
  display: flex;
  align-items: center;
  gap: .4rem;

  &:hover {
    background: ${(props) => props.theme.colors.darkBlueLight};
  }

`;